import { createAction, createSlice } from "@reduxjs/toolkit";

const updateProfileSlice = createSlice({
  name: "updateProfile",
  initialState: { processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = updateProfileSlice;
const updateProfileAction = createAction(name);

export {
  updateProfileAction,
  actions as updateProfileActions,
  reducer as updateProfileReducer,
};
